// src/components/ui/DateInput.js
import Input from "./Input";
export default function DateInput(props) {
  return <Input {...props} type="date" />;
}
